import uuid from 'uuid/v4';
export var generateUniqueNodeKey = function generateUniqueNodeKey() {
  return uuid();
};